import { Drawer as AntDrawer } from 'antd'

export const Drawer = ({ onKeyDown, ...props }) => {
  return <div tabIndex={-1} onKeyDown={onKeyDown}>
    <AntDrawer {...props}/>
  </div>
}
